import Vue from 'vue'

export async function getTypesOfClaim ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setTypesOfClaim', null)
    const { data } = await Vue.axios({
      url: '/typesofclaim'
    })
    commit('setTypesOfClaim', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}
